<template>
  <v-app class="app-background" v-loading.fullscreen.lock="updatePassword.isLoading">
    <div class="welcome-page">
      <el-card shadow="always" class="welcome-container pa-3">
        <img src="../../assets/logoFix.png" alt srcset class="welcome-image mb-4" />
        <el-form :model="user" status-icon :rules="rules" ref="user" class="demo-form-inline w-100">
          <el-form-item prop="newPassword">
            <el-input
              v-model="user.newPassword"
              placeholder="Password Baru"
              show-password
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>

          <el-form-item prop="newPasswordConfirm">
            <el-input
              v-model="user.newPasswordConfirm"
              placeholder="Konfirmasi Password Baru"
              show-password
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item class="mt-4 mr-0 w-100">
            <el-button :disabled="btnSubmitDisable" type="primary" @click="loginUser" class="w-100">Reset Password</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="bg-ellips"></div>
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
        this.btnSubmitDisable = true
      }  else if (value.length < 6 ) {
        callback(new Error('Please input the password minimal 6 character'));
        this.btnSubmitDisable = true
      } else {
        if (this.user.newPasswordConfirm !== '') {
          this.$refs.user.validateField('newPasswordConfirm');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
        this.btnSubmitDisable = true
      } else if (value !== this.user.newPassword) {
        callback(new Error('Two inputs don\'t match!'));
        this.btnSubmitDisable = true
      } else if (value.length < 6 ) {
        callback(new Error('Please input the password minimal 6 character'));
        this.btnSubmitDisable = true
      } else {
        this.btnSubmitDisable = false
        callback();
      }
    };
    return {
      showPassword: false,
      remember: false,
      loading: false,
      alert: {},
      btnSubmitDisable: true,
      user: {
        newPassword: "",
        newPasswordConfirm: ""
      },
      rules: {
        newPassword: [
          { validator: validatePass1, trigger: 'change' }
        ],
        newPasswordConfirm: [
          { validator: validatePass2, trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    ...mapActions({
      resetPassword: "resetPassword/resetPassword"
    }),
    async loginUser() {
      const body = {
        password: this.user.newPassword,
        resetToken: this.$route.params.resetToken
      }
      this.resetPassword(body);
      this.resetForm('user');
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    ...mapState({
      updatePassword: state => state.resetPassword
    })
  }
};
</script>

<style>
.title-login {
  color: #1b2733;
  margin: 25px 0 25px 0;
}
.custom-text-field .v-input__control .v-input__slot {
  border-radius: 20px !important;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.05) !important;
  border: solid 1px #dfe2e6 !important;
  background-color: #ffffff;
}
.forgot-password {
  text-decoration: none;
}
.welcome-page {
  text-align: center;
  height: 100%;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-align: center;
  box-pack: center;
  background: linear-gradient(
    198.13deg,
    #1f36be 0.4%,
    #2883d7 50.55%,
    #2fc5ed 93.01%
  );
  overflow: hidden;
  position: relative;
}
.welcome-page .bg-ellips {
  position: absolute;
  width: 2101px;
  height: 1204px;
  top: 50%;
  z-index: 0;
  border-radius: 50%;
  opacity: 0.3;
  background: linear-gradient(
    190.42deg,
    #1f36be 0.4%,
    #2883d7 50.55%,
    #2fc5ed 93.01%
  );
}
.welcome-container {
  width: 30rem;
  z-index: 9;
}
.welcome-image {
  cursor: pointer;
  width: 16rem;
  height: 6rem;
  object-fit: cover;
}
.w-100 {
  width: 100% !important;
}
.el-form-item__content {
  width: 100% !important;
}
</style>
